import React, { memo } from 'react';
import Box from '@mui/material/Box';
import {
  APP_HEADER_NAVIGATION_HEIGHT,
  INSURANCE_BUYING_FLOW_DETAILS_WIDTH,
} from 'common/constants/styles.constant';

const styles = {
  root: {
    display: 'flex',
    flexDirection: {
      xs: 'column',
      md: 'row',
    },
    gap: 2,
  },
  detailsView: {
    position: 'relative',
    order: {
      xs: 1,
      md: 2,
    },
    minWidth: {
      xs: '100%',
      md: INSURANCE_BUYING_FLOW_DETAILS_WIDTH,
    },
    width: {
      xs: '100%',
      md: INSURANCE_BUYING_FLOW_DETAILS_WIDTH,
    },
    /* TODO: find another way to animate */
    '> :first-of-type': {
      position: 'sticky',
      top: APP_HEADER_NAVIGATION_HEIGHT + 16,
    },
  },
  formView: {
    width: '100%',
    bgcolor: 'grey.50',
    borderRadius: 3,
    order: {
      xs: 2,
      md: 1,
    },
  },
};

interface InsuranceBuyingFlowFormDrawerProps {
  form: JSX.Element;
  details?: JSX.Element;
  padding?: number;
}

function InsuranceBuyingFlowFormDrawer({
  padding = 0,
  form,
  details,
}: InsuranceBuyingFlowFormDrawerProps) {
  return (
    <Box sx={styles.root}>
      <Box p={padding} sx={styles.formView}>
        {form}
      </Box>
      {details && <Box sx={styles.detailsView}>{details}</Box>}
    </Box>
  );
}

export default memo(InsuranceBuyingFlowFormDrawer);
